
import React, { useState } from 'react';


import {
    InputCopy,
    FormGroup,
    Select,
    Tooltip,
    StatusDot,
    Checkbox,
    Subheader,
    Pill,
    Button,
    Breadcrumbs,
    Head,
    FormFooter,
    Card,
    Input,
    RadioGroup,
    Switch,
    Icon,
    ButtonAction,
    Tag,
    Notification,
    ContentBlock,
    StepTabs
} from 'xsolla-uikit';

import { PAskuName } from '../PAskuName';

import PAContentBlock from "../PAContentBlock";


export default function TempSkuName() {

  const [step, setStep] = useState(0)

  const steps = [
    {
      label: 'Currency',
      value: 0,
      onClick: ()=>setStep(0)
    },
    {
      label: 'Set packages',
      value: 1,
      // disabled: true
      onClick: ()=>setStep(1)
    }]

  return (
    <div>

{/* <FormGroup indentation="lg">
      <StepTabs
        current={step}
        steps = {[...steps]}
      />
</FormGroup> */}

<FormGroup indentation="lg">
  <PAskuName

    label = "Currency name"
    sku = {{
      value: "gold_coins",
      shown: false
    }}
    name = {{
      value: "Gold Coins",
      languages: false,
      content: ["Gold Coins", "Золотые монеты", "Алтын"]
    }}

  />
</FormGroup>




    </div>
  )
}
